var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-wrap lb-side-left mt-1"},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"progress-lb-wrap",attrs:{"id":_vm.data.id,"title":_vm.data.title}},[_c('label',{staticClass:"progress-label mnw-50p"},[_vm._v(_vm._s(_vm.data.number))]),_c('div',{staticClass:"progress progress-bar-rounded progress-bar-xs"},[_c('div',{staticClass:"progress-bar",class:_vm.data.class,style:({
          width: `${_vm.data.progress}%`,
          backgroundColor: `${_vm.data.color}`
      })})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }